/**
 * A file just to import globals. Used as a webpack entry point just to be able to
 * cause react etc to be loaded on window. Additionally, any dependendies of tal that should be loaded
 * before an application's code should go here.  For example, `initEventRegistry` establishes global pub /sub,
 * if not created before an app is loaded may not be able to addListeners
 */

import "./globals";
import "@babel/polyfill";
import { initEventRegistry } from "@origin-digital/event-registry";

// this needs to be done first before any event-listeners are created
initEventRegistry();
